export default __webpack_public_path__ + "static/media/document-search-primary.d80d9472.svg";